export default "__VITE_ASSET__6ad8f6f3__"